import { render, staticRenderFns } from "./register-activate-biometry.vue?vue&type=template&id=7dd7f10a&"
import script from "./register-activate-biometry.vue?vue&type=script&lang=js&"
export * from "./register-activate-biometry.vue?vue&type=script&lang=js&"
import style0 from "./register-activate-biometry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports